// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { ControlFilled, UsergroupAddOutlined, UserOutlined, ShopOutlined, TeamOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';
import { ProfileOutlined, ReadOutlined, TagFilled } from '@ant-design/icons/lib/icons';
import useAuthContext from 'context/useAuthContext';
import useGlobalContext from 'context/useGlobalContext';
import { FeedOutlined, LocationCityOutlined, LocationOnOutlined } from '@mui/icons-material';
import { useEffect } from 'react';

// icons
const icons = {
	controlFilled: ControlFilled,
	usergroupAddOutlined: UsergroupAddOutlined,
	teamOutlined: TeamOutlined,
	userOutlined: UserOutlined,
	shopOutlined: ShopOutlined,
	locationCityOutlined: LocationCityOutlined,
	locationOnOutlined: LocationOnOutlined,
	tagFilled: TagFilled,
	profileOutlined: ProfileOutlined,
	readOutlined: ReadOutlined,
	feedOutlined: FeedOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function UserMenuItems() {
	const { permissions, roles } = useAuthContext();
	const { activeCompany } = useGlobalContext();

	let items: NavItemType = {};

	if (permissions) {
		if (
			permissions.some((el: string) => {
				return (
					el === 'Base_Setting' ||
					el === 'Manage_Users' ||
					el === 'Manage_Batches' ||
					el === 'View_Batches' ||
					el === 'Manage_Roles' ||
					el === 'Manage_Sponsors' ||
					el === 'Manage_Employees' ||
					el === 'Manage_Trainers' ||
					el === 'Manage_Learners' ||
					el === 'View_Learners' ||
					el === 'Manage_User_Profile' ||
					el === 'Review_CPD_Record' ||
					el === 'View_Payments' ||
					el === 'Manage_Feedback_Sessions' ||
					el === 'Review_Payments'
				);
			})
		) {
			items = {
				id: 'group-users',
				title: 'Users',
				type: 'group',
				icon: icons.userOutlined,
				children: []
			};

			// items.children.push({
			//     id: 'group-users-users',
			//     title: 'Users',
			//     type: 'item',
			//     icon: icons.usergroupAddOutlined,
			//     url: '/app/users',
			//     breadcrumbs: false
			// });

			if (
				permissions.some((el: string) => {
					return el === 'Manage_Batches' || el === 'View_Batches';
				})
			) {
				items.children.push({
					id: 'core-batch-list-batch',
					divider: true,
					dividerTitle: 'Batches',
					title: 'Batches',
					type: 'item',
					url: '/app/batch/list/batches',
					icon: icons.usergroupAddOutlined,
					breadcrumbs: true
				});
			}
			if (
				permissions.some((el: string) => {
					return el === 'Manage_Feedback_Sessions';
				})
			) {
				items.children.push({
					id: 'core-batch-list-feedback-sessions',
					title: 'Feedback Sessions',
					type: 'item',
					url: '/app/batch/list/feedback/sessions',
					icon: icons.feedOutlined,
					breadcrumbs: true
				});
			}

			if (
				permissions.some((el: string) => {
					return el === 'My_Batches';
				})
			) {
				items.children.push({
					id: 'core-batch-list-my-batches',
					title: 'My Batches',
					type: 'item',
					url: '/app/batch/list/my/batches',
					icon: icons.usergroupAddOutlined,
					breadcrumbs: true
				});
			}

			if (activeCompany.value == null) {
				if (
					permissions.some((el: string) => {
						return el === 'Manage_Companies';
					})
				) {
					items.children.push({
						id: 'group-users-companies',
						divider: true,
						dividerTitle: '',
						title: 'Companies',
						type: 'item',
						icon: icons.shopOutlined,
						url: '/app/users/companies',
						breadcrumbs: true
					});
				}
				if (
					permissions.some((el: string) => {
						return el === 'Base_Setting';
					})
				) {
					items.children.push({
						id: 'core-setting-hr-branches',
						title: 'Branches',
						type: 'item',
						icon: icons.shopOutlined,
						url: '/app/settings/hr/branches',
						breadcrumbs: true
					});
				}
			}

			// if (
			// 	permissions.some((el: string) => {
			// 		return el === 'Base_Setting';
			// 	})
			// ) {
			// 	items.children.push({
			// 		id: 'core-setting-hr-locations',
			// 		title: 'Training Locations',
			// 		type: 'item',
			// 		icon: icons.locationOnOutlined,
			// 		url: '/app/settings/hr/training/locations',
			// 		breadcrumbs: true
			// 	});
			// }

			if (
				permissions.some((el: string) => {
					return (
						el === 'Manage_Sponsors' ||
						el === 'Manage_Trainers' ||
						el === 'Manage_Learners' ||
						el === 'View_Learners' ||
						el === 'View_Payments' ||
						el === 'Review_Payments'
					);
				})
			) {
				let users_menu = {
					id: 'group-users',
					title: 'Users',
					type: 'collapse',
					icon: icons.teamOutlined,
					breadcrumbs: true,
					children: []
				};
				if (
					permissions.some((el: string) => {
						return el === 'Manage_Learners' || el === 'View_Learners' || el === 'View_Payments' || el === 'Review_Payments';
					})
				) {
					users_menu.children.push({
						id: 'group-users-learners',
						// divider: true,
						// dividerTitle: 'Users',
						title: 'Learners',
						type: 'item',
						// icon: icons.teamOutlined,
						url: '/app/users/learners',
						breadcrumbs: true
					});
				}
				if (
					permissions.some((el: string) => {
						return el === 'Manage_Trainers';
					})
				) {
					users_menu.children.push({
						id: 'group-users-trainers',
						title: 'Trainers',
						type: 'item',
						// icon: icons.teamOutlined,
						url: '/app/users/trainers',
						breadcrumbs: true
					});
				}
				if (
					permissions.some((el: string) => {
						return el === 'Manage_Sponsors';
					})
				) {
					users_menu.children.push({
						id: 'group-users-sponsors',
						title: 'Sponsors',
						type: 'item',
						// icon: icons.tagFilled,
						url: '/app/users/sponsors',
						breadcrumbs: true
					});
				}

				items.children.push(users_menu);
			}

			if (
				permissions.some((el: string) => {
					return el === 'Manage_Employees';
				})
			) {
				items.children.push({
					id: 'core-hr-employees',
					divider: true,
					dividerTitle: 'Hr',
					title: 'Employees',
					type: 'item',
					url: '/app/hr/employees',
					icon: icons.userOutlined,
					breadcrumbs: true
				});
			}

			if (
				permissions.some((el: string) => {
					return el === 'Manage_Roles';
				})
			) {
				items.children.push({
					id: 'core-hr-roles',
					title: 'Roles',
					type: 'item',
					url: '/app/hr/roles',
					icon: icons.controlFilled,
					breadcrumbs: true
				});
			}

			if (
				permissions.some((el: string) => {
					return el === 'Base_Setting';
				})
			) {
				if (
					permissions.some((el: string) => {
						return el === 'Review_CPD_Record';
					})
				) {
					items.children.push({
						id: 'core-reports-cpd-manage',
						divider: true,
						dividerTitle: 'Competencies',
						title: 'Manage CPD',
						type: 'item',
						url: '/app/stats/cpd/manage',
						icon: icons.readOutlined,
						breadcrumbs: true
					});
				}
				if (activeCompany.value == null) {
					items.children.push({
						id: 'core-setting-profile-cpd-activity-type',
						title: 'CPD Activity',
						type: 'item',
						url: '/app/settings/profile/activity/types',
						icon: icons.readOutlined,
						breadcrumbs: true
					});
				}
				items.children.push({
					id: 'core-setting-profile-cpd-year-targets',
					title: 'CPD Year Targets',
					type: 'item',
					url: '/app/settings/profile/year/targets',
					icon: icons.readOutlined,
					breadcrumbs: true
				});
			}

			if (activeCompany.value == null) {
				if (
					permissions.some((el: string) => {
						return el === 'Base_Setting';
					})
				) {
					let profile_setting = {
						id: 'core-setting-profile',
						divider: true,
						dividerTitle: 'Settings',
						title: 'Profile Setting',
						type: 'collapse',
						icon: icons.profileOutlined,
						breadcrumbs: true,
						children: []
					};

					profile_setting.children.push({
						id: 'core-setting-profile-certification-type',
						divider: true,
						dividerTitle: 'Profile',
						title: 'Certification Type',
						type: 'item',
						url: '/app/settings/profile/certification/types',
						breadcrumbs: true
					});
					profile_setting.children.push({
						id: 'core-setting-profile-education-type',
						title: 'Education Type',
						type: 'item',
						url: '/app/settings/profile/education/types',
						breadcrumbs: true
					});
					profile_setting.children.push({
						id: 'core-setting-profile-membership-type',
						title: 'Membership Type',
						type: 'item',
						url: '/app/settings/profile/membership/types',
						breadcrumbs: true
					});
					profile_setting.children.push({
						id: 'core-setting-profile-experience-type',
						title: 'Experience Type',
						type: 'item',
						url: '/app/settings/profile/experience/types',
						breadcrumbs: true
					});
					// profile_setting.children.push({
					// 	id: 'core-setting-profile-cpd-activity-type',
					// 	divider: true,
					// 	dividerTitle: 'CPD',
					// 	title: 'CPD Activity',
					// 	type: 'item',
					// 	url: '/app/settings/profile/activity/types',
					// 	breadcrumbs: true
					// });
					// profile_setting.children.push({
					// 	id: 'core-setting-profile-cpd-year-targets',
					// 	title: 'CPD Year Targets',
					// 	type: 'item',
					// 	url: '/app/settings/profile/year/targets',
					// 	breadcrumbs: true
					// });

					profile_setting.children.push({
						id: 'core-setting-hr-departments',
						divider: true,
						dividerTitle: 'HR',
						title: 'Departments',
						type: 'item',
						url: '/app/settings/hr/departments',
						breadcrumbs: true
					});

					profile_setting.children.push({
						id: 'core-setting-hr-job-titles',
						title: 'Job Titles',
						type: 'item',
						url: '/app/settings/hr/job/titles',
						breadcrumbs: true
					});

					// profile_setting.children.push({
					// 	id: 'core-setting-hr-branches',
					// 	title: 'Branches',
					// 	type: 'item',
					// 	url: '/app/settings/hr/branches',
					// 	breadcrumbs: true
					// });

					items.children.push(profile_setting);
				}
			}

			if (
				permissions.some((el: string) => {
					return el === 'Base_Setting' || 'Manage_Custom_Emails';
				})
			) {
				let batch_setting_menu = {
					id: 'group-batch_setting',
					title: 'Batch Settings',
					type: 'collapse',
					icon: icons.usergroupAddOutlined,
					breadcrumbs: true,
					children: []
				};
				if (
					permissions.some((el: string) => {
						return el === 'Base_Setting';
					})
				) {
					batch_setting_menu.children.push({
						id: 'group-batch_setting-training_locations',
						title: 'Training Locations',
						type: 'item',
						url: '/app/settings/hr/training/locations',
						breadcrumbs: true
					});
				}

				if (
					permissions.some((el: string) => {
						return el === 'Manage_Custom_Emails';
					})
				) {
					batch_setting_menu.children.push({
						id: 'group-batch_setting-custom_email_templates',
						title: 'Custom Email Templates',
						type: 'item',
						url: '/app/settings/custom/email/templates',
						breadcrumbs: true
					});
				}

				if (
					permissions.some((el: string) => {
						return el === 'Base_Setting';
					})
				) {
					batch_setting_menu.children.push({
						id: 'group-batch_setting-lecture_templates',
						title: 'Schedule Templates',
						type: 'item',
						url: '/app/batch/list/schedule/templates',
						breadcrumbs: true
					});

					batch_setting_menu.children.push({
						id: 'group-batch_setting-assessment_templates',
						title: 'Assessment Templates',
						type: 'item',
						url: '/app/batch/list/assessment/criteria/templates',
						breadcrumbs: true
					});
					batch_setting_menu.children.push({
						id: 'group-batch_setting-exam_question_templates',
						title: 'Exam Question Templates',
						type: 'item',
						url: '/app/exam/bank/question/templates',
						breadcrumbs: true
					});
				}

				items.children.push(batch_setting_menu);
			}
		}
	}

	return items;
}
